import { render, staticRenderFns } from "./CheckForm.vue?vue&type=template&id=0a75f19b&scoped=true&lang=pug"
import script from "./CheckForm.vue?vue&type=script&lang=js"
export * from "./CheckForm.vue?vue&type=script&lang=js"
import style0 from "./CheckForm.vue?vue&type=style&index=0&id=0a75f19b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a75f19b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a75f19b')) {
      api.createRecord('0a75f19b', component.options)
    } else {
      api.reload('0a75f19b', component.options)
    }
    module.hot.accept("./CheckForm.vue?vue&type=template&id=0a75f19b&scoped=true&lang=pug", function () {
      api.rerender('0a75f19b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/childrensday2024/components/CheckForm.vue"
export default component.exports